import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Expand } from "lucide-react";
import { altOf, useSite, visibleGallery } from "@/lib/content";
import { useSeo } from "@/lib/seo";
import { t } from "@/lib/i18n";
import PageIntro from "@/components/PageIntro";
import Photo from "@/components/Photo";
import Lightbox from "@/components/Lightbox";
import { path } from "@/lib/routes";

export default function Galeri() {
  useSeo("galeri");
  const { content, isPreview } = useSite();
  const items = visibleGallery(content, isPreview);
  const [open, setOpen] = useState(null);

  if (!items.length) return <Navigate to={path("home")} replace />;

  return (
    <div data-testid="galeri-page">
      <PageIntro eyebrow={t("galeri.eyebrow")} title={t("galeri.title")} text={t("galeri.text")} testId="galeri-intro" />
      <section className="safe-x max-w-7xl mx-auto pb-24 lg:pb-32">
        <ul className="masonry" data-testid="gallery-grid">
          {items.map((g, i) => (
            <li key={g.id}>
              <button
                type="button"
                onClick={() => setOpen(i)}
                className="group relative block w-full overflow-hidden rounded-xl sm:rounded-2xl bg-cream-2"
                aria-label={`${t("galeri.open")}: ${altOf(g, isPreview)}`}
                data-testid={`gallery-item-${g.id}`}
              >
                <Photo img={g} isPreview={isPreview} eager={i < 2} sizes="(min-width:1024px) 33vw, 50vw" imgClassName="transition-transform duration-700 group-hover:scale-[1.04]" badgeClass="top-2 left-2" />
                <span className="absolute bottom-3 right-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/85 text-forest opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity" aria-hidden="true">
                  <Expand className="h-4 w-4" />
                </span>
              </button>
            </li>
          ))}
        </ul>
      </section>
      {open !== null && <Lightbox items={items} index={open} onChange={setOpen} onClose={() => setOpen(null)} isPreview={isPreview} />}
    </div>
  );
}
